export const getTrackdeskParams = () => {
    const params = new URLSearchParams(window.location.search);
    const sourceId = params.get("sourceId");
    const linkId = params.get("linkId");
    const tenantId = params.get("tenantId");
  
    let query = "";
    if (sourceId && linkId && tenantId) {
      query = `?sourceId=${sourceId}&linkId=${linkId}&tenantId=${tenantId}`;
    }
    return query;
  };
  